import { FILE_UPLOADING_STATUS_NAME } from '../constants'

/**
 * 格式化上传列表表格数据
 * @param {object} progress
 */
export const formatUploadList = (progress = {}) => {
    const data = []
    Object.keys(progress).forEach(fileNameMd5 => {
        const file = progress[fileNameMd5] || {}
        let fileProgress = 0
        switch (file.status) {
            case 1: {
                // 计算进度
                let finishedCount = file.slices.reduce((a, b) => {
                    if (b >= 1) {
                        return a + b - 1
                    }
                    return a + b
                }, 0)
                fileProgress = Math.ceil((finishedCount / file.totalSlice) * 100)
                break
            }
            case 2: {
                fileProgress = 100
                break
            }
            default:
        }
        data.push({
            fileKey: fileNameMd5,
            channelName: file.name,
            status: FILE_UPLOADING_STATUS_NAME[file.status],
            progress: fileProgress,
            appName: file.appInfo && file.appInfo.name,
            originData: file,
        })
    })
    return data
}
